import { Box, Card, CardContent, Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import { AreaChart } from "../../../Components/ReactChart/AreaChart";
import BarChart from "../../../Components/ReactChart/BarChart";
import { DoughnutChart } from "../../../Components/ReactChart/DoughnutChart";
import LineCharts from "../../../Components/ReactChart/LineCharts";
import { PieChart, PieChart2 } from "../../../Components/ReactChart/PieChart";

const Analytics = () => {
  return (
    <>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Card sx={{ minWidth: 32 + "%", height: 290, borderRadius: 3 }}>
              <CardContent>
                <BarChart />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card sx={{ minWidth: 32 + "%", height: 290, borderRadius: 3 }}>
              <CardContent>
                <LineCharts />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card sx={{ minWidth: 32 + "%", height: 530, borderRadius: 3 }}>
              <CardContent>
                <DoughnutChart />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card sx={{ minWidth: 32 + "%", height: 530, borderRadius: 3 }}>
              <CardContent>
                <PieChart />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card sx={{ minWidth: 32 + "%", height: 350, borderRadius: 3 }}>
              <CardContent>
                <AreaChart />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card sx={{ minWidth: 32 + "%", height: 530, borderRadius: 3 }}>
              <CardContent></CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Analytics;
